import store from '@store/index';
import { distructAndDispatch } from '../../core/utils/methods/destruct-and-dispatch';
import { transformFields } from '../../core/utils/methods/transform-fields';
import { PROJECT_CATEGORY_TRANSFORM_FIELDS } from '../../models/constants/transform-fields';
import { ProjectCategory, ProjectDetails } from '../../models/interfaces';
import { ProjectCategoriesActions } from '../actions/project-categories.actions';

export namespace ProjectCategoriesEffects {
  export const setProjectCategoriesFromDetails = distructAndDispatch<
    ProjectDetails,
    ProjectCategory[]
  >(
    'categories',
    ProjectCategoriesActions.setProjectCategoriesAction,
    (categories: ProjectCategory[]) =>
      categories?.map((category: ProjectCategory) =>
        transformFields<ProjectCategory>(
          category,
          PROJECT_CATEGORY_TRANSFORM_FIELDS,
        ),
      ),
  );

  export const setProjectCategories = (categories: ProjectCategory[]): void => {
    const transformedCategories = categories?.map((category: ProjectCategory) =>
      transformFields<ProjectCategory>(
        category,
        PROJECT_CATEGORY_TRANSFORM_FIELDS,
      ),
    );

    store.dispatch(
      ProjectCategoriesActions.setProjectCategoriesAction.done(
        transformedCategories,
      ),
    );
  };
}
